export default __webpack_public_path__ + "static/media/boxmoving.f75d6dd5.svg";